import { api } from './api';

interface UploadBrandLogoResult {
  url: string;
  error?: string;
}

export const uploadBrandLogo = async (file: File): Promise<UploadBrandLogoResult> => {
  try {
    // Validate file
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
    if (!validTypes.includes(file.type)) {
      throw new Error('Invalid file type. Please upload PNG, JPG, or SVG.');
    }

    // 10MB limit
    if (file.size > 10 * 1024 * 1024) {
      throw new Error('File size must be less than 10MB.');
    }

    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post<{ success: boolean; url: string }>('/api/media/brand-logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return { url: response.data.url };
  } catch (error: any) {
    console.error('Error uploading brand logo:', error);
    return { url: '', error: error.message || 'Failed to upload logo' };
  }
};

export const deleteBrandLogo = async (logoUrl: string): Promise<void> => {
  try {
    await api.delete('/api/media/brand-logo', {
      data: { logoUrl }
    });
  } catch (error: any) {
    console.error('Error deleting brand logo:', error);
    throw error;
  }
};
